import { Component, inject } from '@angular/core';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';
import { CurrentService } from 'src/app/services/current.service';

/**
 * Preview de l'étape Environnement.
 * Affiche la photo de fond correspondant à l'emplacement sélectionné.
 */
@Component({
  selector: 'ng-casto-closet-doors-standard-preview-environment',
  templateUrl: './preview-step-environment.component.html',
  styleUrls: ['./preview-step-environment.component.scss'],
})
export class PreviewStepEnvironmentComponent {
  private readonly current = inject(CurrentService);
  private readonly closetDoorsService = inject(ClosetDoorsStandardService);

  /** Préfixe d'URL pour les images servies par l'API. */
  protected readonly baseImgURL = this.closetDoorsService.apiUrl;

  /** Emplacement sélectionné par l'utilisateur (contient la photo de fond). */
  protected get selectedEmplacement() {
    return this.current.closetDoors.selectedEmplacement;
  }
}
